import React from 'react';
import { CheckIcon, XIcon } from 'lucide-react';
import { SectionCTA } from './SectionCTA';
import { afterItems, beforeItems } from '../data/content';
export function BeforeAfter() {
  return <section className="w-full bg-white px-5 py-16 md:px-8 md:py-24" data-id="element-56" data-mp="3ogauvp93qz4s">
      <div className="mx-auto max-w-5xl" data-id="element-57" data-mp="3oi45tgqr05il">
        <h2 className="text-center font-serif text-[1.85rem] font-extrabold leading-tight text-navy-900 sm:text-4xl md:text-5xl" data-id="element-58" data-mp="3sgbkm61niwr5">
          From scattered clinical findings to an organized corrective planning workflow
        </h2>

        <div className="mt-12 grid gap-6 md:grid-cols-2" data-id="element-59" data-mp="3jhzm7hujmuo5">
          <div className="rounded-3xl border-2 border-red-200 bg-red-50 p-6 sm:p-8" data-id="element-60" data-mp="34sjx06anuxak">
            <p className="inline-block rounded-full bg-red-600 px-4 py-1.5 text-sm font-extrabold uppercase tracking-wider text-white" data-id="element-61" data-mp="39qby9qx73vrf">
              Before
            </p>
            <h3 className="mt-4 text-xl font-bold text-red-900" data-id="element-62" data-mp="2vtgeb3feojwl">Without a structured decision system</h3>
            <ul className="mt-6 space-y-4" data-id="element-63" data-mp="x4k3r0bzjy6t">
              {beforeItems.map(item => <li key={item} className="flex gap-3 text-base leading-relaxed text-red-950" data-id="element-64" data-mp="x6ep2fr65sbf">
                  <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-red-600" data-id="element-65" data-mp="t51lydfgo387">
                    <XIcon className="h-4 w-4 text-white" strokeWidth={3} aria-hidden="true" data-id="element-66" data-mp="123n6uf8enuc5" />
                  </span>
                  {item}
                </li>)}
            </ul>
          </div>

          <div className="rounded-3xl border-2 border-emerald-300 bg-emerald-50 p-6 sm:p-8" data-id="element-67" data-mp="9fhn9vt38bdw">
            <p className="inline-block rounded-full bg-emerald-600 px-4 py-1.5 text-sm font-extrabold uppercase tracking-wider text-white" data-id="element-68" data-mp="o3lzcgxmxonp">
              After
            </p>
            <h3 className="mt-4 text-xl font-bold text-emerald-900" data-id="element-69" data-mp="jbc9f0wisolf">With the Veneer Complication Decision Map™</h3>
            <ul className="mt-6 space-y-4" data-id="element-70" data-mp="3mu5lf99nh5dh">
              {afterItems.map(item => <li key={item} className="flex gap-3 text-base leading-relaxed text-emerald-950" data-id="element-71" data-mp="1qqr3m4xl2fx8">
                  <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-emerald-600" data-id="element-72" data-mp="1vpua7tt7ou7b">
                    <CheckIcon className="h-4 w-4 text-white" strokeWidth={3} aria-hidden="true" data-id="element-73" data-mp="20g0x9p82s6ng" />
                  </span>
                  {item}
                </li>)}
            </ul>
          </div>
        </div>

        <div className="mx-auto mt-12 max-w-3xl rounded-3xl bg-navy-900 p-7 text-center text-white sm:p-10" data-id="element-74" data-mp="17t6ohpkmevpt">
          <h3 className="font-serif text-2xl font-bold text-gold-300 sm:text-3xl" data-id="element-75" data-mp="1crhxxz70747i">The transformation</h3>
          <p className="mt-4 text-lg leading-relaxed" data-id="element-76" data-mp="1gr8l7sxbn27a">
            From an unstructured complication case to a documented assessment and corrective
            planning record — organized through five clear decision stages.
          </p>
          <p className="mt-5 text-base text-navy-100" data-id="element-77" data-mp="2x6jm6vy89lhy">
            No promised clinical outcomes. No replacement for professional judgment. Just a practical
            system for making the assessment and planning process more organized.
          </p>
        </div>

        <SectionCTA label="Yes! I Want the 'After' Workflow" data-id="element-78" data-mp="32cf8u9uvhj6t" />
      </div>
    </section>;
}